export default (store) => (next) => (action) => {
  const result = next(action)
  if (action.meta?.callback) action.meta.callback(store.getState())
  return result
}
